import { changeActiveRole } from "@/auth/change-active-role";
import { create } from "zustand";

const ACTIVE_ROLE_STORAGE_KEY = "activeRoleId";

const getInitialActiveRoleId = () => {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(ACTIVE_ROLE_STORAGE_KEY);
};

type ActiveRoleStore = {
  activeRoleId: string | null;
  setActiveRoleId: (roleId: string) => Promise<void>;
  hydrateActiveRole: (roleId: string | null) => void;
};

export const useActiveRoleStore = create<ActiveRoleStore>((set) => ({
  activeRoleId: getInitialActiveRoleId(),
  setActiveRoleId: async (roleId) => {
    try {
      if (typeof window !== "undefined") {
        localStorage.setItem(ACTIVE_ROLE_STORAGE_KEY, roleId);
      }
      set({ activeRoleId: roleId });
      await changeActiveRole(Number(roleId));
    } catch (error) {
      console.error("Failed to change active role", error);
      throw error;
    }
  },
  hydrateActiveRole: (roleId) => {
    const normalizedRoleId = roleId ?? null;
    if (typeof window !== "undefined") {
      if (normalizedRoleId) {
        localStorage.setItem(ACTIVE_ROLE_STORAGE_KEY, normalizedRoleId);
      } else {
        localStorage.removeItem(ACTIVE_ROLE_STORAGE_KEY);
      }
    }
    set({ activeRoleId: normalizedRoleId });
  }
}));
